import type { AttrSchema } from "@easysaas/widget-core";

/** Single source of truth for this widget's data-attributes.
 *  Used both at runtime (defineWidget) and at build time (configurator-page generator
 *  in scripts/post-build.ts). UI hints (label, group, step, min) are optional and
 *  ignored by the runtime parser. */
export const attrs = {
  widthRef: {
    type: "number",
    default: 205,
    label: "Reifen 1 — Breite (mm)",
    group: "Reifen 1 (Referenz)",
    step: 5,
    min: 100,
    max: 400,
  },
  aspectRef: {
    type: "number",
    default: 55,
    label: "Reifen 1 — Querschnitt (%)",
    group: "Reifen 1 (Referenz)",
    step: 5,
    min: 20,
    max: 95,
  },
  inchesRef: {
    type: "number",
    default: 16,
    label: "Reifen 1 — Zoll",
    group: "Reifen 1 (Referenz)",
    step: 0.5,
    min: 10,
    max: 24,
  },
  widthNew: {
    type: "number",
    default: 195,
    label: "Reifen 2 — Breite (mm)",
    group: "Reifen 2 (neu)",
    step: 5,
    min: 100,
    max: 400,
  },
  aspectNew: {
    type: "number",
    default: 55,
    label: "Reifen 2 — Querschnitt (%)",
    group: "Reifen 2 (neu)",
    step: 5,
    min: 20,
    max: 95,
  },
  inchesNew: {
    type: "number",
    default: 16,
    label: "Reifen 2 — Zoll",
    group: "Reifen 2 (neu)",
    step: 0.5,
    min: 10,
    max: 24,
  },
  tolerancePercentMin: {
    type: "number",
    default: -4,
    label: "Toleranz untere Grenze (%)",
    group: "Toleranz",
    step: 0.5,
    min: -20,
    max: 0,
  },
  tolerancePercentMax: {
    type: "number",
    default: 1,
    label: "Toleranz obere Grenze (%)",
    group: "Toleranz",
    step: 0.5,
    min: 0,
    max: 20,
  },
} as const satisfies AttrSchema;
